// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"559":"edit-tema","842":"edit-temaer"}[chunkId] + "." + {"559":"af14fcd2","842":"e85c2f4a"}[chunkId] + ".js";
};